import ProductLicenseModal from "./LicenseGridModal"
import ProductLicenseGrid from "./LicenseGrid"
import Button from "components/common/controls/Button";

interface Props {
  onClose: () => void;
}

export default function LicenseManagement (props: Props) {
  const { onClose } = props;
  return (
    <>
      <ProductLicenseModal onClose={() => onClose?.()}>
        <div>
          <Button
            text={"Cancel"}
            variant="secondary"
            className="float-right"
            onClick={() => onClose?.()}
          />
          <ProductLicenseGrid />
        </div>
      </ProductLicenseModal>
    </>
  );
}